import { createContext, useContext } from "react";

// Contexts partagés entre App.js et les pages extraites (CheckoutPage, DashboardPage, …).
// Centraliser ici évite la dépendance circulaire (page → App → page).
export const AuthContext = createContext(null);
export const CartContext = createContext(null);

export const useAuth = () => useContext(AuthContext);
export const useCart = () => useContext(CartContext);
